import CustomTooltip from '../../shared/CustomTooltip';
import { Grid, useMediaQuery } from '@mui/material';
import React, { useMemo } from 'react';
import ExperienceCard from './ExperienceCard';
import IndividualExperienceDetails from './IndividualExperienceDetails';

type DiscountDateRange = {
    startDate: string | Date;
    endDate: string | Date;
};

const ExperiencesListAll = ({
    experiences,
    visitType,
    component,
    isSmallChat,
    mapOpen,
    wishlistedIds,
    onRemoveFromWishlist,
}: {
    experiences: any[];
    visitType: string;
    component?: string;
    isSmallChat?: boolean;
    mapOpen?: boolean;
    wishlistedIds?: number[];
    onRemoveFromWishlist?: (experienceId: number) => void;
}) => {
    const experienceList = useMemo(() => experiences, [experiences]);
    const isMobile = useMediaQuery('(max-width: 770px)');

    return (
        <>
            {experienceList.map((experience: any) => {
                return (
                    <Grid
                        key={experience.name}
                        item
                        xs={isSmallChat ? 30 : mapOpen ? 30 : 60}
                        sm={isSmallChat ? 30 : mapOpen ? 30 : 30}
                        md={isSmallChat ? 30 : mapOpen ? 30 : 20}
                        lg={isSmallChat ? 30 : mapOpen ? 30 : 15}
                        xl={isSmallChat ? 30 : mapOpen ? 30 : 12}
                    >
                        {component === 'aiGuestReservation' && !isMobile ? (
                            <CustomTooltip
                                placement='right'
                                arrow
                                title={
                                    <IndividualExperienceDetails
                                        value={experience}
                                        component={component}
                                    />
                                }
                            >
                                {
                                    <ExperienceCard
                                        experience={experience}
                                        component={component}
                                        visitType={visitType}
                                        isSmallChat={isSmallChat}
                                        isWishlisted={wishlistedIds?.includes(
                                            experience.id,
                                        )}
                                        onRemoveFromWishlist={
                                            onRemoveFromWishlist
                                        }
                                    />
                                }
                            </CustomTooltip>
                        ) : (
                            <ExperienceCard
                                experience={experience}
                                visitType={visitType}
                                isWishlisted={wishlistedIds?.includes(
                                    experience.id,
                                )}
                                onRemoveFromWishlist={onRemoveFromWishlist}
                            />
                        )}
                    </Grid>
                );
            })}
        </>
    );
};

export default React.memo(ExperiencesListAll);
